// Управление SEO-тегами документа: <title>, description, canonical, robots
// и разметка Schema.org.
//
// У каждого экрана приложения свой адрес, и теги для него Drupal отдаёт уже
// в исходной разметке — их печатает модуль metatag. Здесь теги обновляются
// при переходах внутри приложения, когда html уже отрисован: тег всегда
// переиспользуется, а не добавляется заново, поэтому на странице остаётся
// ровно один <title>, один description, один canonical, один robots и один
// блок ld+json. Тексты для обоих мест приходят из Drupal — см. app/data/seo.js.

import { plainText } from '@/utils/text';

// Значение по умолчанию для страниц, открытых к индексации.
export const DEFAULT_ROBOTS = 'index, follow';

const ensureMetaTag = (name) => {
  let tag = document.head.querySelector(`meta[name="${name}"]`);

  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('name', name);
    document.head.appendChild(tag);
  }

  return tag;
};

const ensureCanonicalTag = () => {
  let tag = document.head.querySelector('link[rel="canonical"]');

  if (!tag) {
    tag = document.createElement('link');
    tag.setAttribute('rel', 'canonical');
    document.head.appendChild(tag);
  }

  return tag;
};

// Разметку Schema.org Drupal отдаёт готовой строкой json — той же, что
// стоит в исходной разметке (см. Drupal\ruchoco_common\Plugin\metatag).
const ensureJsonLdTag = () => {
  let tag = document.head.querySelector('script[type="application/ld+json"]');

  if (!tag) {
    tag = document.createElement('script');
    tag.setAttribute('type', 'application/ld+json');
    document.head.appendChild(tag);
  }

  return tag;
};

// Canonical равен url страницы без get-параметров. Путь передаёт роутер:
// у главной он отличается от адреса в строке браузера (см. router/index.js).
export const canonicalUrl = (path) =>
  `${window.location.origin}${path || window.location.pathname}`;

// Пустое значение оставляет тег как есть: пустой title или description хуже
// того, что уже стоит на странице.
export const applyPageMeta = ({ title, description, robots, jsonld, canonical } = {}) => {
  if (title) {
    document.title = title;
  }

  if (description) {
    ensureMetaTag('description').setAttribute('content', plainText(description));
  }

  if (jsonld) {
    ensureJsonLdTag().textContent = jsonld;
  }

  ensureMetaTag('robots').setAttribute('content', robots || DEFAULT_ROBOTS);
  ensureCanonicalTag().setAttribute('href', canonicalUrl(canonical));
};
